import { render, staticRenderFns } from "./OtpForm.vue?vue&type=template&id=06bb574a&scoped=true&"
import script from "./OtpForm.vue?vue&type=script&lang=js&"
export * from "./OtpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb574a",
  null
  
)

export default component.exports